import { Form, InputNumber } from 'antd';
import { ACCESSORIAL_UNIT_LABELS } from '../../../policies/rate-card-labels';
import type { AccessorialType } from '../../../rate-cards.api';

/** Hours or days free before the charge starts — asked only for a type that carries one, and then required, as the server holds it. */
export function FreeQuantityField({ type }: { type: AccessorialType | undefined }) {
  if (!type?.hasFreeQuantity) return null;
  const unit = type.unit === 'per_day' ? 'days' : 'hours';

  return (
    <Form.Item
      name="freeQuantity"
      label={`Free ${unit}`}
      extra={`${ACCESSORIAL_UNIT_LABELS[type.unit]} charge starts after this many`}
      rules={[{ required: true, message: `Enter the free ${unit}` }]}
    >
      <InputNumber className="w-full" min={0} precision={0} />
    </Form.Item>
  );
}
